import React from 'react';
import Dashboard from "./dashboard/Dashboard";
import PedidosRev from './pedidos/PedidosRev';

const RotasRev = [
    { label: "Home", rota: "home", icon: 'home', subitems: [], component: <Dashboard /> },
    
    {   
        label: "Pedidos de Venda", rota: "pedidos-venda-revendedora", icon: "shopping_bag", component: <PedidosRev />, subitems: []    
    }
];

export default RotasRev;